import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { EstadoAutorizacion } from './EstadoAutorizacion';
import { PreviewBox } from '../Common/PreviewBox';
import { PreviewField } from '../Common/PreviewField';
import { PreviewFieldContainer } from '../Common/PreviewFieldContainer';
import { PreviewFileField } from '../Common/PreviewFileField';
import ButtonBack from '../Breadcrumb/ButtonBack';
import React from 'react';
import { AdjuntarDocumentacion } from './components/AdjuntarDocumentacion';

const formatNumber = (value = 0) => {
  const formatter = new Intl.NumberFormat('es-ES');
  const result = formatter.format(value);
  return result;
};

const formatDate = (value = null) => {
  if (!value) {
    return;
  }
  const date = new Date(value);
  const result = new Intl.DateTimeFormat('es-AR').format(date);
  return result;
};

const agruparYOrdenarDocumentacion = (documentacion = []) => {
  if (!Array.isArray(documentacion)) return [];

  const grupos = documentacion.reduce((acc, doc) => {
    const codigo = doc?.codigoDocumentacion;
    if (!codigo) return acc;

    if (!acc[codigo]) {
      acc[codigo] = [];
    }

    acc[codigo].push(doc);
    return acc;
  }, {});

  return Object.keys(grupos)
    .map((codigo) => ({ codigo, documentos: grupos[codigo] }))
    .sort((a, b) => parseInt(a.codigo) - parseInt(b.codigo));
};

export const CODIGO_ESTADO_APROBADO = '4';

export const VerAutorizacion = () => {
  const history = useHistory();
  const { autorizacion } = history?.location?.state || {};
  const documentacionList = agruparYOrdenarDocumentacion(autorizacion?.documentacion || []);

  return (
    <Grid container spacing={2}>
      <ButtonBack />
      <Grid item xs={12}>
        <Card sx={{ paddingX: { xs: 0, sm: 1 } }}>
          <CardContent>
            <Grid container spacing={1} rowSpacing={1} gap={1}>
              <Grid item>
                <Typography variant='h5' component={'span'}>
                  Consulta de Solicitud de Autorización
                </Typography>
              </Grid>
              {autorizacion?.estado?.codigoEstado && (
                <Grid item xs={12}>
                  <EstadoAutorizacion estadoSolicitud={autorizacion.estado} />
                </Grid>
              )}
              <Grid item xs={12}>
                <PreviewBox title='Solicitud de Autorización' alignItems='center'>
                  <Grid item xs={12} sm={6}>
                    <PreviewField
                      id='id'
                      label='Número'
                      value={autorizacion.solicitudCobertura.idSolicitudCoberturaFormateado}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PreviewField
                      id='tipoTramite'
                      label='Tipo de Trámite'
                      value={autorizacion.tipoCobertura.descripcion}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PreviewField
                      id='fechaDeSolicitud'
                      label='Fecha de Solicitud'
                      value={formatDate(autorizacion.solicitudCobertura.fechaGenerada) || '-'}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PreviewField
                      id='estadoActual'
                      label='Estado'
                      value={autorizacion.estado.descripcionEstadoSolicitudCobertura}
                    />
                  </Grid>
                  {autorizacion.estado.codigoEstado === CODIGO_ESTADO_APROBADO && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <PreviewFieldContainer>
                          <PreviewFileField
                            id='formatted-text-mask-input'
                            label={
                              'Providencia ' +
                              formatNumber(autorizacion.estado.idHistorialEstadoSolicitudCobertura)
                            }
                            href={autorizacion.providenciaUrl}
                          />
                        </PreviewFieldContainer>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <PreviewField
                          id='fechaInicio'
                          label='Inicio Vigencia'
                          value={formatDate(autorizacion.solicitudCobertura.fechaIniciada) || '-'}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <PreviewField
                          id='fechaVencimiento'
                          label='Vencimiento'
                          value={formatDate(autorizacion.solicitudCobertura.vencimiento) || '-'}
                        />
                      </Grid>
                    </>
                  )}
                </PreviewBox>
              </Grid>
              <Grid item xs={12}>
                <PreviewBox title='Documentación Presentada'>
                  {documentacionList?.length > 0 &&
                    documentacionList.map((grupo) => {
                      if (grupo?.documentos?.length === 0) {
                        return null;
                      }

                      return (
                        <React.Fragment key={grupo.codigo}>
                          {grupo.documentos.map((doc, idx) => {
                            return (
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                key={doc.idHistorialDocumentacionSolicitudCobertura}
                              >
                                <PreviewFieldContainer>
                                  <PreviewFileField
                                    label={`${doc.documentacion} - ${idx + 1}`}
                                    src={doc?.path || ''}
                                  />
                                </PreviewFieldContainer>
                              </Grid>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}

                  {/* {pedidosMedicos.map((pedidoMedico, idx) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        key={pedidoMedico.idHistorialDocumentacionSolicitudCobertura}
                      >
                        <PreviewFieldContainer>
                          <PreviewFileField
                            label={`Pedido Médico - ${idx + 1}`}
                            src={pedidoMedico?.path || ''}
                          />
                        </PreviewFieldContainer>
                      </Grid>
                    );
                  })}

                  {resultadosEstudios.map((resultadoEstudio, idx) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        key={resultadoEstudio.idHistorialDocumentacionSolicitudCobertura}
                      >
                        <PreviewFieldContainer>
                          <PreviewFileField
                            label={`Estudio Previo - ${idx + 1}`}
                            src={resultadoEstudio?.path || ''}
                          />
                        </PreviewFieldContainer>
                      </Grid>
                    );
                  })} */}
                </PreviewBox>
              </Grid>
              <Grid item xs={12}>
                <PreviewBox title='Afiliado'>
                  <Grid item xs={12} sm={6}>
                    <PreviewField
                      id='dni'
                      label='Documento'
                      value={`${autorizacion.afiliado.numeroDocumentoFormateado}`}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PreviewField
                      id='nya'
                      label='Apellido y Nombre'
                      value={`${autorizacion.afiliado.apellidoNombreFormateado}`}
                    />
                  </Grid>
                </PreviewBox>
              </Grid>
              {autorizacion.practicas && autorizacion.practicas.length > 0 && (
                <Grid item xs={12}>
                  <PreviewBox title='Prácticas'>
                    {autorizacion.practicas?.map((item, idx) => {
                      const cols =
                        autorizacion.practicas.length === 1
                          ? 12
                          : autorizacion.practicas.length === 2
                          ? 6
                          : 4;
                      return (
                        <Grid item xs={12} md={cols} key={idx}>
                          <PreviewField
                            id='rp1'
                            label={`RP${idx + 1}`}
                            value={item?.trim()}
                            multiline
                            maxRows={4}
                          />
                        </Grid>
                      );
                    })}
                  </PreviewBox>
                </Grid>
              )}
              <Grid item xs={12}>
                <PreviewBox title={'Observaciones'}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px',
                      alignItems: 'flex-end',
                      pb: 1,
                    }}
                  >
                    <PreviewField
                      id='observaciones'
                      label={''}
                      value={
                        autorizacion?.estado?.observacion
                          ? `${autorizacion.estado.observacion[0].toUpperCase()}${autorizacion.estado.observacion.slice(
                              1,
                            )}`
                          : '-'
                      }
                      multiline
                    />
                    {autorizacion?.estado?.codigoEstado === '11' && (
                      <AdjuntarDocumentacion
                        autorizacion={{
                          idSolicitudCobertura: autorizacion.solicitudCobertura.idSolicitudCobertura,
                          idSolicitudCoberturaFormateado:
                            autorizacion.solicitudCobertura.idSolicitudCoberturaFormateado,
                          tipoCobertura: autorizacion.tipoCobertura.descripcion,
                          afiliado: autorizacion.afiliado.apellidoNombreFormateado,
                          numerodocumento: autorizacion.afiliado.numeroDocumentoFormateado,
                          idGrupoTipoCobertura: autorizacion.tipoCobertura.idGrupoTipoCobertura,
                          estado: autorizacion.estado.descripcionEstadoSolicitudCobertura,
                          codigoEstado: autorizacion.estado.codigoEstado,
                          observacion: autorizacion.estado.observacion,
                          fechaestado: autorizacion.estado.fechaDesde,
                          idOrdenAsociada: autorizacion.ordenAsociada,
                          correo: autorizacion.afiliado.correo,
                          practicas: autorizacion.practicas,
                          id: autorizacion.solicitudCobertura.idSolicitudCobertura,
                        }}
                      />
                    )}
                  </Grid>
                </PreviewBox>
              </Grid>
              {/* <Grid item xs={12}>
                <PreviewBox title='Pedidos Médicos'>
                  {pedidosMedicos?.map((item, idx) => {
                    const cols =
                      pedidosMedicos.length === 1 ? 12 : pedidosMedicos.length === 2 ? 6 : 4;
                    return (
                      <Grid item xs={12} md={cols} key={idx}>
                        <PreviewFileField
                          id='rp1'
                          label={`Archivo Adjunto ${idx + 1}`}
                          href={item.link}
                          path={item.path}
                        />
                      </Grid>
                    );
                  })}
                </PreviewBox>
              </Grid>
              {resultadosEstudios && resultadosEstudios.length > 0 && (
                <Grid item xs={12}>
                  <PreviewBox title='Resultados de Estudios'>
                    {resultadosEstudios?.map((item, idx) => {
                      const cols =
                        resultadosEstudios.length === 1
                          ? 12
                          : resultadosEstudios.length === 2
                          ? 6
                          : 4;
                      return (
                        <Grid item xs={12} md={cols} key={idx}>
                          <PreviewFileField
                            id='rp1'
                            label={`Archivo Adjunto ${idx + 1}`}
                            href={item.path}
                          />
                        </Grid>
                      );
                    })}
                  </PreviewBox>
                </Grid>
              )} */}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
